import { useEffect, useState, useRef } from 'react'
import { backendAccessGet, backendAccessPost } from '../../../Utils/Authentication'

import Table from 'react-bootstrap/Table'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'

export function CreateNextRotation( props )
{
    const setRotations = props.setRotations

    const [ rotationName, setRotationName ] = useState("")

    const createRotation = () => {
        if( rotationName == "" )
        {
            alert("Please insert the rotation name.")
            return
        }

        var data = {}
        data['rotation_name'] = rotationName

        backendAccessPost('/api/rotations/create-next/', data ).then( res => {
            if( 'error_message' in res )
            {
                alert( res['error_message'] )
                return
            }
            setRotations( res['rotations'] )
        })
    }

    const undoStep = () => {
        var data = {}
        backendAccessPost('/api/rotations/undo-step/', data ).then( res => {
            if( 'error_message' in res )
            {
                alert( res['error_message'] )
                return
            }
            setRotations( res['rotations'] )
        })
    }

    const resetAllRotations = () => {
        var check = window.confirm("Are you sure you want to reset the rotations?")
        
        if( !check )
        {
            return
        }

        var data = {}

        backendAccessPost('/api/rotations/reset-all/', data ).then( res => {
            if( 'error_message' in res )
            {
                alert( res['error_message'] )
                return
            }
            setRotations( res['rotations'] )
        })
    }

    return (
        <>
            <div>
                <b>Create the next rotation</b>
            </div>
            <div style={{ width:'100%', backgroundColor:'#F5F5F5', padding:'10px',
                          borderRadius:'10px', marginBottom:'15px'}}>
                <InputGroup style={{ width:'600px'}}>
                    <Form.Control value={rotationName} onChange={ e => setRotationName(e.target.value) } placeholder="Rotation name"/>
                    <Button variant="secondary" onClick={createRotation}>Create</Button>
                    <Button variant="secondary" onClick={undoStep}>Undo</Button>
                    <Button variant="danger" onClick={resetAllRotations}>Reset All</Button>
                </InputGroup>
            </div>
        </>
    )
}

export function CreateRotationModal( props )
{
    const showModal = props.showModal 
    const setShowModal = props.setShowModal 

    const setRotations = props.setRotations
    
    const [ name, setName ] = useState("")
    const [ nameError, setNameError ] = useState(false)

    useEffect( () => {
        if( showModal )
        {
            setName("")
            setNameError(false)
        }
    }, [ showModal] )

    const create = () => {
        setNameError(false)

        let has_error = false
        if( name == "" )
        {
            setNameError(true)
            has_error = true 
        }

        var data = {}
        data['rotation_name'] = name

        backendAccessPost('/api/planner/rotations/rotations/create-next/', data ).then( res => {
            if( 'error_message' in res )
            {
                alert( res['error_message'] )
                return
            }
            setRotations( res['rotations'] )
            setShowModal(false)
        })
    }

    return (
        <Modal show={showModal} onHide={ e => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Create next rotation</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding:'10px'}}>
                <div>
                    <b>Rotation Name</b>
                </div>
                <div style={{ marginBottom:'10px' }}>
                    <Form.Control value={name} onChange={e => setName(e.target.value)} isInvalid={nameError} />
                </div> 
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={e => setShowModal(false)}>
                    Close
                </Button>
                <Button variant="primary" onClick={create}>
                    Create
                </Button>

            </Modal.Footer>

        </Modal>
    )
}


export function RotationView( props )
{
    const residents = props.residents
    const rotations = props.rotations
    const setRotations = props.setRotations
    const positions = props.positions
    const setShowCreateModal = props.setShowCreateModal 

    const [ positionsList, setPositionsList ] = useState(null)
    const [ matchings, setMatchings ] = useState(null)
    const [ rotationNames, setRotationNames ] = useState(null)
    const [ timeIndices, setTimeIndices ] = useState(null)

    const reload = () => {
        var positions_list_ = []

        for( var p_idx in positions )
        {
            for( var i=0 ; i<positions[p_idx].capacity ; i++ )
            {
                positions_list_.push( positions[p_idx].name + "(" + (i+1) + ")" )
            }
        }

        var residents_dict = {}
        for( var r_idx in residents )
        {
            var rid = residents[r_idx].uid 
            residents_dict[rid] = residents[r_idx]
        }

        var matchings_ = []
        var rotation_names_ = []
        var time_indices_ = []

        for( var r_idx in rotations )
        {
            var positions_count = {}
            for( var p_idx in positions )
            {
                positions_count[ positions[p_idx].name ] = 0
            }

            var time_idx = rotations[r_idx].time_idx
            var matching = rotations[r_idx].matching 

            var matching_dict = {}

            for( var m_idx in matching )
            {
                var pos = matching[m_idx].position

                var pos_code = pos.name + "(" + (positions_count[pos.name]+1) + ")"
                positions_count[pos.name] += 1

                var name = "Deleted"

                if( m_idx in residents_dict )
                {
                    name = residents_dict[m_idx].firstname + " " + residents_dict[m_idx].lastname                }

                matching_dict[pos_code] = name
            }

            matchings_.push( matching_dict )
            rotation_names_.push( rotations[r_idx].name )
            time_indices_.push( time_idx ) 
        }

        setPositionsList( positions_list_ )
        setMatchings( matchings_ )
        setRotationNames( rotation_names_ )
        setTimeIndices( time_indices_ )
    }

    useEffect( () => {
        reload()
    }, [])

    useEffect( () => {
        reload()
    }, [ residents, rotations, positions ])

    const exportCSV = () => {
        var rows = []
        var headers = []

        headers.push("Name")

        for( var p_idx in positionsList )
        {
            headers.push( positionsList[p_idx] )
        }

        headers = headers.join(",")

        rows.push( headers )

        for( var t_idx in timeIndices )
        {
            var row = []
            row.push( rotationNames[t_idx] )

            for( var p_idx in positionsList )
            {
                row.push( matchings[t_idx][positionsList[p_idx]] )
            }
            row = row.join(",")
            rows.push( row )
        }

        var data = rows.join("\n")

        data = new Blob([data], {type: 'text/csv'});
        var csvURL = window.URL.createObjectURL(data);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'rotations.csv');
        tempLink.click();
    }

    const undoStep = () => {
        var check = window.confirm("Undo last created rotation?")

        if( !check )
        {
            return;
        }

        var data = {}
        backendAccessPost('/api/planner/rotations/rotations/undo-step/', data ).then( res => {
            if( 'error_message' in res )
            {
                alert( res['error_message'] )
                return
            }
            setRotations( res['rotations'] )
        })
    }


    return (
        <>
            <div className="d-flex justify-content-center align-items-center" 
                 style={{ width:'100%', height:'100px'}}>
                <ButtonGroup size="sm">
                    <Button variant="secondary" onClick={e => setShowCreateModal(true)}>Create</Button>
                    <Button variant="danger" onClick={undoStep}>Undo</Button>
                    <Button variant="secondary" onClick={exportCSV}>Export CSV</Button>
                </ButtonGroup>
            </div>

            <div style={{ width:'100%', height:'100%',padding:'10px',
                      borderRadius:'10px', overflow:'auto', fontSize:'10px'}}>
                { ( positionsList && matchings && timeIndices ) &&
                <Table striped bordered hover>
                    <thead>
                        <th style={{ minWidth:'80px'}}>Name</th>
                        { positionsList.map( (p,idx) => 
                        <th style={{ minWidth:'80px'}}>
                        { p }
                        </th>
                        )}
                    </thead>
                    <tbody>
                        { timeIndices.map( (t,idx) => 
                        <tr>
                            <td>{ rotationNames[idx] }</td>
                            { positionsList.map( (p,idy) => 
                            <td>{ matchings[idx][p] }</td>
                            )}
                        </tr>
                        )} 
                    </tbody>
                </Table>
                }
            </div>
        </>
    )
}


export default function RotationBuilder( props )
{
    const activeKey = props.activeKey 

    const [ residents, setResidents ] = useState( null )
    const [ rotations, setRotations ] = useState( null )
    const [ positions, setPositions ] = useState( null )

    const [ showCreateModal, setShowCreateModal ] = useState(false)

    const load = () => {
        var data = {}
        backendAccessPost('/api/planner/rotations/rotations/fetch/', data ).then( res => {
            if('error_message' in res )
            {
                alert( res['error_message'] )
                {
                    return
                }
            }

            setResidents( res['residents'] )
            setRotations( res['rotations'] )
            setPositions( res['positions'] )
        })
    }

    useEffect( () => {
        if( activeKey != "rotations" )
        {
            return
        }

        load()

    }, [activeKey])


    return (
        <>
            
            <div style={{width:'100%'}}>
                { ( residents && rotations ) &&
                <RotationView residents={residents}
                              rotations={rotations}
                              setRotations={setRotations}
                              positions={positions}
                              setShowCreateModal={setShowCreateModal}
                />
                }
            </div>

            <CreateRotationModal showModal={showCreateModal}
                                 setShowModal={setShowCreateModal}
                                 setRotations={setRotations}
            />

        </>
    )
}
